import { Helmet } from 'react-helmet-async';
import { SITE, canonicalUrl } from '../config/site';

const PageSEO = ({
  title,
  description,
  path = '',
  ogTitle,
  ogDescription,
  noindex = false,
  // Only for routes that don't correspond to a real resource (invalid
  // :id/:slug, catch-all 404). A self-canonical there would claim the
  // requested (non-existent) URL is the canonical version of itself — a
  // false signal. Real pages that are merely noindexed for now (e.g. thin
  // content pending expansion) should keep their self-canonical as usual;
  // noindex and "no canonical" are independent decisions.
  omitCanonical = false,
}) => {
  const canonical = canonicalUrl(path);
  const resolvedTitle = ogTitle || title;
  const resolvedDesc = ogDescription || description;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? 'noindex,follow' : 'index,follow'} />
      {!omitCanonical && <link rel="canonical" href={canonical} />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={resolvedTitle} />
      {resolvedDesc && <meta property="og:description" content={resolvedDesc} />}
      <meta property="og:image" content={SITE.ogImage.url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      {resolvedDesc && <meta name="twitter:description" content={resolvedDesc} />}
      <meta name="twitter:image" content={SITE.ogImage.url} />
    </Helmet>
  );
};

export default PageSEO;
